export class Metrics {
    constructor() {
        this.values = {};
        this.metrics = {};
    }
    counter(name) {
        if (!this.metrics[name]) {
            this.metrics[name] = new Counter(this.values, name);
        }
        return this.metrics[name];
    }
}
export function presetLabels(labels, metrics) {
    return Object.fromEntries(Object.entries(metrics).map(([key, val]) => {
        return [key, val.labels(labels)];
    }));
}
/**
 * A counter is a cumulative metric that represents a single numerical value that only ever goes up
 */
export class Counter {
    constructor(values, name) {
        this.values = values;
        this.name = name;
    }
    inc(value) {
        this.increase("", value || 1);
    }
    labels(labels) {
        let serialized = Object.entries(labels).map(entry => entry.join(":")).join(",");
        return {
            inc: (value) => {
                this.increase(serialized, value || 1, labels);
            },
        };
    }
    increase(serializedLabel, value, labels) {
        let key = this.name + "!" + serializedLabel;
        let entry = this.values[key];
        if (!entry) {
            entry = { value, labels };
            this.values[key] = entry;
        }
        entry.value += value;
    }
}
